<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  color: #2c3e50;
}
.el-message-box {
  margin-top: -150px!important;
}
.el-dialog {
  margin-top: 70px!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue